import PropTypes from "prop-types";
import { CancelTransactionModal } from "components/investments/CancelTransactionModal";
import { useInvestmentCancellation } from "hooks/useInvestmentCancellation";

/** Wires cancel-investment flow (confirm → modal → API) for a list section. */
export function InvestmentCancellationBound({ onSuccess, children }) {
  const cancellation = useInvestmentCancellation({ onSuccess });

  return (
    <>
      {children(cancellation)}
      <CancelTransactionModal
        open={cancellation.modalOpen}
        onOpenChange={cancellation.setModalOpen}
        investment={cancellation.investment}
        cancellationNotes={cancellation.cancellationNotes}
        onNotesChange={cancellation.handleNotesChange}
        notesError={cancellation.notesError}
        submitting={cancellation.submitting}
        investorEmail={cancellation.investorEmail}
        onConfirm={cancellation.submitCancellation}
        onClose={cancellation.closeModal}
      />
    </>
  );
}

InvestmentCancellationBound.propTypes = {
  onSuccess: PropTypes.func,
  children: PropTypes.func.isRequired,
};

InvestmentCancellationBound.defaultProps = {
  onSuccess: undefined,
};
